export default "__VITE_ASSET__CNtp6XXc__"